// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-pagination[data-v-4fb2c747]{border:.5px solid #dee2e6;background:#fff;color:#007a4a;text-align:center;font-family:Trebuchet MS;font-size:14px;padding:4px 8px;min-width:31px}.button-pagination-selected[data-v-4fb2c747]{color:#fff;background-color:#007a4a}.button-pagination[data-v-4fb2c747]:disabled{border:.5px solid #dee2e6;background:#dee2e6;color:#6c757d}.button-pagination.button-ellipsis[data-v-4fb2c747]{border:.5px solid #dee2e6;background:#fff;color:#6c757d}", ""]);
// Exports
module.exports = exports;
